<template>
  <div v-if="showModal" class="modal-overlay" >
    <div class="modal-content">
      <span class="close-button" @click="closeModal">&times;</span>
      <!-- <h2>確認折抵時數</h2> -->
      <h2>確認折抵</h2>
      <!-- <p>您的信用卡點數最多可以折抵 {{ discountHours }} 小時，請選擇是否要進行折抵</p> -->
      <!-- <button class="apply-button" @click="confirmDiscount">使用折抵 {{ discountHours }} 小時</button> -->
      <button class="apply-button" @click="confirmDiscount">使用折抵</button>
      <button class="cancel-button" @click="cancelDiscount">取消折抵</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true,
      // maxDiscountHours: 1 // Replace with the actual discount hours value as needed
    };
  },
  props: {
    discountHours: {
      type: Number,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('discountCancelled');
    },
    confirmDiscount() {
      // this.$emit('updateState', { key: 'discountHours', value: this.maxDiscountHours });
      this.$emit('discount-hours-selected');
    },
    cancelDiscount() {
      this.$emit('cancel-discount');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 10px;
  margin-top: 30vh;

  width: 480px;
  padding: 24px 30px;
  position: relative;
  text-align: center;
  box-sizing: border-box;
  align-items: center;
}

h2 {
  font-size: 24px;
  color: var(--green03);
  margin-top: 0;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  width:330px;
  color: #333;
  /* margin: 20px 0 40px; */
  margin: 20px auto;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  color: black;
}

.apply-button, .cancel-button {
  width: 200px;
  padding: 16px;
  border-radius: 99px;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  box-sizing: border-box;
}

.apply-button {
  background-color: var(--green03);
  color: white;
  border: none;
}

.apply-button:hover {
  background-color: var(--green02);
}

.cancel-button {
  background-color: white;
  color: var(--green03);
  border: 1px solid var(--green03);
  margin-bottom:32px;
}

.cancel-button:hover {
  background-color: #f5f5f5;
}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    width: 343px;
  }

  h2 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
    margin: 20px 0;
  }

  .apply-button, .cancel-button {
    font-size: 16px;
    padding: 12px;
  }
}
</style>
